<template>
	<div class="modalContainer" id="registrationFormModal">
		<div class="modal col-11 col-md-8 col-lg-6 py-3">
			<span class="close modalClose" @click="closeModal">
				<i class="fas fa-times"></i>
			</span>
			<div class="text-center">
				<h2 class="mb-0">Conference Registration</h2>
				<div class="w-50 mx-auto">
					<p>
						For Presentations, please use the Submit abstracts form.
					</p>
				</div>
			</div>
			<div v-if="!formSent">
				<form @submit="handleForm($event)" id="quotationForm">
					<div class="inputGroup halfGroup mb-5">
						<label for="">Organization Name</label>
						<input
							type="text"
							class="text-input"
							v-model="user.organization"
							required
						/>
					</div>

					<div class="inputGroup halfGroup mb-5">
						<label for="">Position/Title</label>
						<input
							type="text"
							class="text-input"
							v-model="user.title"
							required
						/>
					</div>

					<div class="inputGroup halfGroup mb-5">
						<label for="">First Name</label>
						<input
							type="text"
							class="text-input"
							v-model="user.first_name"
							required
						/>
					</div>

					<div class="inputGroup halfGroup mb-5">
						<label for="">Last Name</label>
						<input
							type="text"
							class="text-input"
							v-model="user.last_name"
							required
						/>
					</div>

					<div class="inputGroup halfGroup mb-5">
						<label for="">Email Address</label>
						<input
							type="text"
							class="text-input"
							v-model="user.email"
							required
						/>
					</div>

					<div class="inputGroup halfGroup mb-5">
						<label for="">Phone number</label>
						<input
							type="text"
							class="text-input"
							v-model="user.phone_number"
							required
						/>
					</div>

					<div class="inputGroup halfGroup mb-5">
						<label for="">Town/City:</label>
						<input
							type="text"
							class="text-input"
							v-model="user.town"
						/>
					</div>

					<div class="inputGroup halfGroup mb-5">
						<label for="">Country</label>
						<input
							type="text"
							class="text-input"
							v-model="this.user.country"
							required
						/>
					</div>
					<div class="inputGroup mb-5">
						<label for="">Fees: </label>
						<div
							class="checkboxGroup"
							v-for="fee in fees"
							:key="fee.id"
						>
							<input
								type="radio"
								name="is_member"
								v-bind:id="'fee-' + fee.id"
								v-bind:value="fee.id"
								@change="handleMembership"
								required
							/>
							<label :for="'fee-' + fee.id">{{
								fee.name + ': ' + fee.amount + ' ' + fee.currency
							}}</label>
						</div>
					</div>

					<div class="inputGroup text-center">
						<button class="secondary" id="submitBtn">
							Send &nbsp;
							<i class="fas fa-paper-plane"></i>
						</button>
					</div>
				</form>
			</div>
			<div v-if="formSent" class="text-center">
				<h3 class="text-center">Your Spot has been Reserved!</h3>
				<h4 class="text-center" style="color: white"> Thankyou for being a sponsor. Check your email for more details</h4>
				<span>
					<i class="fas fa-check-double fa-8x"></i>
				</span>
			</div>
		</div>
	</div>
</template>

<script>
import Api from "../../../services";
import posthog from "posthog-js";

export default {
	props: ["conference"],
	created() {
		this.getFees();
	},
	data() {
		return {
			user: {
				organization: "",
				title: "",
				first_name: "",
				last_name: "",
				email: "",
				phone_number: "",
				town: "",
				country: "",
				conference: null,
				is_member: "",
			},
			fees: [],
			selectedFeeId: null,
			formSent: false,
		};
	},
	methods: {
		getFees() {
			Api.conferenceFees
				.get("?fee_type=attendee&_sort=id:asc")
				.then((res) => (this.fees = res.data))
				.catch((e) => console.log(e));
		},
		closeModal() {
			var modal = document.getElementById("registrationFormModal");
			modal.style.display = "None";
		},
		updateConference() {
			this.user.conference = this.conference;
		},
		validateForm() {
			if (
				this.user.first_name &&
				this.user.last_name &&
				this.user.email
			) {
				this.user.email = this.user.email.trim();
				return true;
			} else {
				return false;
			}
		},
		loadingBtn(str) {
			var btn = document.getElementById("submitBtn");
			if (btn) {
				btn.innerHTML = str;
			}
		},
		sendEmail(data) {
			Api.sendemail.post({ ...data, template: "conference" }).then(() => {
				Api.sendemail.post({
					...data,
					template: "conferenceConfirmation",
				});
			});
		},
		resetForm() {
			this.selectedFeeId = null;
			this.user = {
				organization: "",
				first_name: "",
				last_name: "",
				email: "",
				phone_number: "",
				town: "",
				country: "",
				conference: null,
				is_member: "",
			};
		},
		handleMembership(e) {
			const selected = this.fees.find((f) => String(f.id) === String(e.target.value));
			if (selected) {
				// Store fee ID separately for email lookup
				this.selectedFeeId = e.target.value;
				// Set is_member as a proper boolean for Strapi
				// Use the is_member flag from Strapi if set, otherwise infer from name
				if (selected.is_member !== null && selected.is_member !== undefined) {
					this.user.is_member = selected.is_member;
				} else {
					this.user.is_member = !(/non.?member/i.test(selected.name));
				}
				this.user.charges = selected.amount;
			}
		},
		handleForm(e) {
			e.preventDefault();
			this.updateConference();
			this.loadingBtn(
				"Sending... <i class='fas fa-circle-notch fa-spin'></i>"
			);
			if (this.validateForm()) {
				Api.conferenceRegistration
					.post(this.user)
					.then((res) => {
						// Capture the selected fee BEFORE resetForm clears state
						const selectedFee = this.fees.find(
							(f) => String(f.id) === String(this.selectedFeeId)
						);
						posthog.identify(this.user.email, {
							name: `${this.user.first_name} ${this.user.last_name}`,
							organization: this.user.organization,
							country: this.user.country,
						});
						posthog.capture("conference_registered", {
							conference_id: this.user.conference,
							is_member: this.user.is_member,
							country: this.user.country,
							fee_amount: selectedFee ? selectedFee.amount : this.user.charges,
							fee_currency: selectedFee ? selectedFee.currency : "",
						});
						this.formSent = true;
						this.loadingBtn("Sent! <i class='fas fa-check'></i>");
						this.sendEmail({
							...res.data,
							fee_name: selectedFee ? selectedFee.name : "",
							fee_amount: selectedFee ? selectedFee.amount : res.data.charges,
							fee_currency: selectedFee ? (selectedFee.currency || "USD") : "",
						});
						setTimeout(() => {
							this.closeModal();
							this.formSent = false;
							this.resetForm();
							this.loadingBtn(
								"Send <i class='fas fa-paper-plane></i>'"
							);
						}, 5000);
					})
					.catch((error) => {
						console.log(typeof error);
						this.loadingBtn(
							`${error.message} <i class='fas fa-exclamation-triangle'></i>`
						);
					});
			}
		},
	},
};
</script>
